import { ButtonProps } from '@chakra-ui/button';
import { Button } from '@telescope/cassini-ui';
import React from 'react';
import { FaFacebook } from 'react-icons/fa';

type FacebookButtonProps = ButtonProps;

export const FacebookButton = ({ children, ...buttonProps }: FacebookButtonProps) => {
  return (
    <Button width="full" colorScheme="facebook" type="button" leftIcon={<FaFacebook />} {...buttonProps}>
      {children}
    </Button>
  );
};
